(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurator"] && !Shopify.designMode) return;
  try {
    
class BicycleConfigurator extends HTMLElement {
 connectedCallback(){
  if(this.ready)return; this.ready=true;
  this.data=JSON.parse(this.querySelector('[data-products]').textContent);
  this.form=this.querySelector('[data-product-form]');
  const query=new URLSearchParams(location.search),initial=this.dataset.product==='base-citybike'?'base':'plus';
  const model=['base','plus'].includes(query.get('model'))?query.get('model'):initial;
  this.form.elements.model.value=model;
  const qcolor=query.get('color');if(['white','grey','olive','beige'].includes(qcolor))this.form.elements.color.value=qcolor;
  this.addEventListener('change',()=>this.refresh());
  const imageDialog=this.querySelector('[data-image-dialog]');
  this.querySelector('[data-zoom]').addEventListener('click',()=>{if(Date.now()<(this.swipeUntil||0))return;const current=this.querySelector('[data-bike-image]'),large=this.querySelector('[data-large-image]');large.src=current.src;large.alt=current.alt;this.querySelector('[data-large-caption]').textContent=current.alt;imageDialog.showModal()});
  this.querySelector('[data-close-image]').addEventListener('click',()=>imageDialog.close());
  this.setupGalleryControls();
  document.addEventListener('DOMContentLoaded',()=>this.refresh(),{once:true});
  this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.querySelector('dialog').close()));
  this.form.addEventListener('submit',async event=>{
   event.preventDefault(); const state=this.refresh();
   if(this.dataset.lock==='true'){this.querySelector('[data-selection]').textContent=state.label+' · '+state.color+' · '+state.price;this.querySelector('dialog').showModal();return;}
   if(!state.variant?.available)return;
   const error=this.querySelector('[data-error]'),button=this.querySelector('[data-buy]');button.disabled=true;error.hidden=true;
   try{const response=await fetch(this.form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:state.variant.id,quantity:1}]})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.data.error);location.assign(this.dataset.root+'cart');}catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;}
  });this.refresh();
 }
 setupGalleryControls(){
  const stage=this.querySelector('.stage'),dialog=this.querySelector('[data-image-dialog]');
  for(const surface of [stage,dialog]){
   for(const direction of [-1,1]){const b=document.createElement('button');b.type='button';b.className='gallery-arrow '+(direction<0?'previous':'next');b.setAttribute('aria-label',direction<0?'Vorheriges Foto':'Nächstes Foto');b.textContent=direction<0?'‹':'›';b.addEventListener('click',()=>this.selectPhoto(this.photoIndex+direction));surface.append(b);}
   surface.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.selectPhoto(this.photoIndex+(e.key==='ArrowRight'?1:-1));});
   let start=null;
   surface.addEventListener('pointerdown',e=>{if(e.button!==0||e.target.closest('button:not([data-zoom])'))return;start={x:e.clientX,y:e.clientY,id:e.pointerId};});
   surface.addEventListener('pointerup',e=>{if(!start||start.id!==e.pointerId)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){this.swipeUntil=Date.now()+400;this.selectPhoto(this.photoIndex+(dx<0?1:-1));}});
   surface.addEventListener('pointercancel',()=>start=null);
   surface.addEventListener('dragstart',e=>e.preventDefault());
  }
 }
 selectPhoto(index,animate=true){
  if(!this.photos?.length)return;
  const previous=this.photoIndex||0;this.photoIndex=(index+this.photos.length)%this.photos.length;
  const photo=this.photos[this.photoIndex],direction=index>=previous?1:-1;
  for(const img of [this.querySelector('[data-bike-image]'),this.querySelector('[data-large-image]')]){
   img.getAnimations().forEach(a=>a.cancel());img.src=photo.image;img.alt=photo.caption;
   if(animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches)img.animate([{opacity:.25,transform:'translateX('+direction*35+'px)'},{opacity:1,transform:'translateX(0)'}],{duration:300,easing:'cubic-bezier(.2,.7,.2,1)'});
  }
  this.querySelector('[data-large-caption]').textContent=photo.caption;
  this.querySelectorAll('[data-gallery] button').forEach((b,i)=>{b.classList.toggle('active',i===this.photoIndex);b.setAttribute('aria-pressed',String(i===this.photoIndex));});
  const gallery=this.querySelector('[data-gallery]'),active=gallery.children[this.photoIndex];
  gallery.scrollTo({left:active.offsetLeft-gallery.offsetLeft-(gallery.clientWidth-active.clientWidth)/2,behavior:animate?'smooth':'instant'});
 }

 refresh(){
  const model=this.form.elements.model.value;const wordmark=this.querySelector('[data-selected-wordmark]');wordmark.src=this.data[model+'Wordmark'];wordmark.alt=model==='base'?'Base':'Plus';
  if(model==='base'&&!['white','grey'].includes(this.form.elements.color.value))this.form.elements.color.value='white';
  const c=this.form.elements.color.value||'white',names={white:'Spotless White',grey:'Boring Grey',olive:'Olive Green',beige:'Sunset Beige'},color=names[c];
  const product=this.data[model],variant=product?.variants?.find(v=>v.option1===color),label=model==='base'?this.data.baseName:this.data.plusName;
  const formatter=new Intl.NumberFormat(this.data.locale||'de-DE',{style:'currency',currency:this.data.currency||'EUR'});
  const price=formatter.format((variant?.price??this.data.previewPrices[model])/100);
  this.querySelectorAll('.model-option').forEach(el=>el.classList.toggle('selected',el.querySelector('input').checked));
  this.querySelectorAll('[data-swatch]').forEach(el=>{el.hidden=model==='base'&&['olive','beige'].includes(el.dataset.swatch);el.classList.toggle('selected',el.dataset.swatch===c)});
  this.querySelector('[data-color-name]').textContent=color;this.querySelector('[data-price]').textContent=price;
  this.querySelector('[data-variant-id]').value=variant?.id||'';
  const verified=model==='plus'&&['white','grey'].includes(c),img=this.querySelector('[data-bike-image]');
  const initialCaption=label+' · '+color;
  this.querySelector('[data-stock]').textContent=this.dataset.lock!=='true'&&!variant?.available?this.data.unavailable:'';
  this.querySelector('[data-buy]').disabled=this.dataset.lock!=='true'&&!variant?.available;
  for(const m of ['base','plus']){const p=this.data[m];if(p?.variants?.length)this.querySelector('[data-model-price="'+m+'"]').textContent=formatter.format(Math.min(...p.variants.map(v=>v.price))/100)}
  const galleryKey=model+'-'+c;
  if(this.galleryKey!==galleryKey){
   this.galleryKey=galleryKey;const photos=[{image:this.data.images[galleryKey],caption:initialCaption},...this.data.gallery[galleryKey].map(p=>({...p,caption:color+' · '+p.caption}))];
   this.photos=photos;this.photoIndex=0;
   const gallery=this.querySelector('[data-gallery]');gallery.replaceChildren();
   photos.forEach((photo,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',(i+1)+': '+photo.caption);button.setAttribute('aria-pressed',String(i===0));button.classList.toggle('active',i===0);const thumbnail=document.createElement('img');thumbnail.src=photo.image;thumbnail.alt='';thumbnail.loading='lazy';thumbnail.width=100;thumbnail.height=100;button.append(thumbnail);button.addEventListener('click',()=>this.selectPhoto(i));gallery.append(button)});this.selectPhoto(0,false);
  }
  document.querySelectorAll('[data-equipment-model]').forEach(el=>el.hidden=el.dataset.equipmentModel!==model);
  return {variant,label,color,price};
 }
}
if(!customElements.get('bicycle-configurator'))customElements.define('bicycle-configurator',BicycleConfigurator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-stories"] && !Shopify.designMode) return;
  try {
    // A single continuous orbit through actual 3D component positions, in metres.
const cameraStops = [
 {p:0, target:[0,.59,0], distance:2.85, azimuth:-.55, elevation:.19},
 {p:.13, target:[-.53,.66,0], distance:1.6, azimuth:-.86, elevation:.24},
 {p:.30, target:[.46,.35,.06], distance:1.25, azimuth:.72, elevation:.32},
 {p:.46, target:[.40,.94,0], distance:1.18, azimuth:.92, elevation:.20},
 {p:.63, target:[.53,.39,-.06], distance:1.26, azimuth:2.75, elevation:.29},
 {p:.79, target:[.37,.935,0], distance:1.3, azimuth:5.55, elevation:-.10},
 {p:.92, target:[-.40,1.18,-.08], distance:1.5, azimuth:5.8, elevation:.5},
 {p:1, target:[0,.60,0], distance:2.85, azimuth:5.75, elevation:.22}
];
const clamp01=n=>Math.max(0,Math.min(1,n));
const mix=(a,b,t)=>a+(b-a)*t;
// Hermite interpolation with shared derivatives preserves velocity at section boundaries.
function curve(points,index,key,t){
 const a=points[index],b=points[index+1],prev=points[Math.max(0,index-1)],next=points[Math.min(points.length-1,index+2)];
 const dt=b.p-a.p,m0=(b[key]-prev[key])/(b.p-prev.p)*dt,m1=(next[key]-a[key])/(next.p-a.p)*dt;
 const t2=t*t,t3=t2*t;
 return (2*t3-3*t2+1)*a[key]+(t3-2*t2+t)*m0+(-2*t3+3*t2)*b[key]+(t3-t2)*m1;
}
function sampleCamera(progress){
 const p=clamp01(progress);let index=cameraStops.findIndex((s,i)=>i<cameraStops.length-1&&p<=cameraStops[i+1].p);if(index<0)index=cameraStops.length-2;
 const t=(p-cameraStops[index].p)/(cameraStops[index+1].p-cameraStops[index].p);
 const result={};for(const key of ['distance','azimuth','elevation'])result[key]=curve(cameraStops,index,key,t);
 result.target=[0,1,2].map(axis=>curve(cameraStops.map(s=>({...s,value:s.target[axis]})),index,'value',t));
 return result;
}
function damp(current,target,delta){return mix(current,target,1-Math.exp(-Math.min(delta,.064)/.12));}
function chapterPosition(progress){
 // Text follows the closest focus point; the camera never stops between points.
 const stops=[.10,.29,.46,.63,.79,.92];
 if(progress<=stops[0])return 0;
 for(let i=0;i<stops.length-1;i++)if(progress<=stops[i+1])return i+clamp01((progress-stops[i])/(stops[i+1]-stops[i]));
 return 5;
}


let sceneScriptPromise,sceneScriptURL;
function loadSceneScript(url){
 if(sceneScriptPromise&&sceneScriptURL===url)return sceneScriptPromise;
 sceneScriptURL=url;
 sceneScriptPromise=new Promise((resolve,reject)=>{
  const script=document.createElement('script');script.src=url;script.async=true;
  script.onload=()=>resolve(window.OTO3D);
  script.onerror=()=>{script.remove();sceneScriptPromise=undefined;reject(new Error('3D scene script unavailable'));};
  document.head.append(script);
 });
 return sceneScriptPromise;
}

// Finish the lighting change early, leaving over a viewport of full night.
function nightAmount(progress){
 const t=clamp01((progress-.08)/.47);
 return t*t*t*(t*(t*6-15)+10);
}

function mountStoryMotion(scope=document) {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const tracks=[...scope.querySelectorAll('[data-scroll-story]')].map(track=>({track,panels:[...track.querySelectorAll('[data-story-panel]')],dots:[...track.querySelectorAll('[data-story-dot]')],host:track.querySelector('[data-bicycle-scene]'),current:0,target:0,top:0,height:1,scene:null,loading:false,failed:false}));
 let raf=0,lastTime=0,disposed=false;
 const measure=()=>{for(const item of tracks){item.top=item.track.getBoundingClientRect().top+scrollY;item.height=Math.max(1,item.track.offsetHeight-innerHeight);}};
 const load=async item=>{
  if(!item.host||item.scene||item.loading||item.failed||reduced.matches)return;
  item.loading=true;
  try{
   const sceneModule=await loadSceneScript(item.host.dataset.sceneModule);
   if(disposed||reduced.matches)return;
   const scene=await sceneModule.createBicycleScene(item.host);
   if(disposed||reduced.matches){scene.dispose();return;}
   item.scene=scene;schedule();
  }catch(error){item.failed=true;item.track.dataset.sceneState='fallback';console.warn('The 3D view could not load; the product photograph remains available.',error);}
  finally{item.loading=false;}
 };
 const frame=time=>{
  raf=0;if(disposed||document.hidden||reduced.matches)return;
  const dt=lastTime?Math.min((time-lastTime)/1000,.064):1/60;lastTime=time;
  let moving=false;
  for(const item of tracks){
   const {track,panels,dots}=item;
   item.target=clamp01((scrollY-item.top)/item.height);
   // Outside the scene, settle instantly so fast page jumps never create a catch-up animation.
   const visible=scrollY+innerHeight>item.top&&scrollY<item.top+item.height+innerHeight;
   item.current=visible?damp(item.current,item.target,dt):item.target;
   if(Math.abs(item.target-item.current)<.00002)item.current=item.target;
   if(visible&&item.current!==item.target)moving=true;
   const progress=item.current;track.style.setProperty('--progress',String(progress));
   if(panels.length){
    const position=chapterPosition(progress),active=Math.round(position);
    panels.forEach((panel,i)=>{const weight=i===active?clamp01((.5-Math.abs(position-active))/.12):0;panel.style.setProperty('--weight',String(weight));panel.setAttribute('aria-hidden',String(i!==active));});
    dots.forEach((dot,i)=>dot.classList.toggle('active',i===active));
    track.dataset.active=String(active);
    if(visible)item.scene?.draw(progress,position);
   }
   if(track.dataset.scrollStory==='night'){
    const light=item.manualLight ?? nightAmount(progress);track.style.setProperty('--night',String(light));
    track.querySelectorAll('[data-light-label]').forEach(label=>{const active=label.dataset.lightLabel===(light>.5?'night':'day');label.classList.toggle('active',active);label.setAttribute('aria-pressed',String(active));});
   }
  }
  if(moving)raf=requestAnimationFrame(frame);else lastTime=0;
 };
 function schedule(){if(!raf&&!disposed&&!reduced.matches&&!document.hidden)raf=requestAnimationFrame(frame);}
 const resize=()=>{measure();schedule();};
 const setup=()=>{
  cancelAnimationFrame(raf);raf=0;lastTime=0;
  tracks.forEach(item=>{
   item.track.classList.toggle('motion-enabled',!reduced.matches);
   if(reduced.matches){item.scene?.dispose();item.scene=null;item.panels.forEach(panel=>panel.setAttribute('aria-hidden','false'));if(item.track.dataset.scrollStory==='night')item.track.style.setProperty('--night','1');}
  });
  measure();if(!reduced.matches){tracks.forEach(item=>{item.current=clamp01((scrollY-item.top)/item.height);if(Math.abs(scrollY-item.top)<innerHeight*2)void load(item)});schedule();}
 };
 tracks.forEach(item=>item.track.querySelectorAll('[data-light-label]').forEach(button=>button.addEventListener('click',()=>{
  item.manualLight=button.dataset.lightLabel==='night'?1:0;
  item.track.style.setProperty('--night',String(item.manualLight));
  item.track.querySelectorAll('[data-light-label]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active));});
  schedule();
 })));
 const observer=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){const item=tracks.find(i=>i.track===entry.target);if(item)void load(item)}},{rootMargin:'100% 0px'});
 tracks.forEach(item=>observer.observe(item.track));
 const sizes=new ResizeObserver(resize);tracks.forEach(item=>sizes.observe(item.track));
 const visibility=()=>{lastTime=0;if(!document.hidden)schedule();};
 setup();addEventListener('scroll',schedule,{passive:true});addEventListener('resize',resize);document.addEventListener('visibilitychange',visibility);reduced.addEventListener('change',setup);
 return()=>{disposed=true;cancelAnimationFrame(raf);observer.disconnect();sizes.disconnect();tracks.forEach(item=>item.scene?.dispose());removeEventListener('scroll',schedule);removeEventListener('resize',resize);document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',setup);};
}

class BicycleEditorial extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.cleanup=mountStoryMotion(this);
  const toggle=this.querySelector('.motion-toggle'),color=this.querySelector('.color-story');
  const pauseLabel=toggle.getAttribute('aria-label'),playLabel=this.dataset.playLabel;
  toggle.addEventListener('click',()=>{const paused=color.classList.toggle('is-paused');toggle.setAttribute('aria-label',paused?playLabel:pauseLabel);toggle.innerHTML=paused?'<span aria-hidden="true">▶</span>':'<span aria-hidden="true">Ⅱ</span>'});
 }
 disconnectedCallback(){this.cleanup?.();this.ready=false}
}
if(!customElements.get('bicycle-editorial'))customElements.define('bicycle-editorial',BicycleEditorial);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy"]) return;
  try {
    
class PrivacySettings extends HTMLElement {
 connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('[data-open-privacy]').addEventListener('click',async()=>{
  const error=this.querySelector('[data-consent-error]');error.hidden=true;
  try{
   if(!window.privacyBanner){await new Promise((resolve,reject)=>{const script=document.createElement('script');script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';script.onload=resolve;script.onerror=reject;document.head.append(script);});}
   await window.privacyBanner.showPreferences();
  }catch(e){error.hidden=false;}
 });}
}
if(!customElements.get('privacy-settings'))customElements.define('privacy-settings',PrivacySettings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal"]) return;
  try {
    
const withdrawalForm=document.getElementById('OtoWithdrawal');
if(withdrawalForm?.querySelector('[data-withdrawal-review]')){
 const dialog=document.querySelector('.withdrawal-review');let confirmed=false;
 withdrawalForm.addEventListener('submit',event=>{if(confirmed)return;event.preventDefault();const summary=dialog.querySelector('[data-withdrawal-summary]');summary.replaceChildren();for(const [label,id] of [['Name','WithdrawalName'],['E-Mail','WithdrawalEmail'],['Bestellung','WithdrawalOrder'],['Erklärung','WithdrawalBody']]){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=document.getElementById(id).value;summary.append(dt,dd);}dialog.showModal();});
 dialog.querySelectorAll('[data-withdrawal-back]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
 dialog.querySelector('[data-withdrawal-confirm]').addEventListener('click',()=>{confirmed=true;dialog.close();withdrawalForm.requestSubmit();});
}

  } catch(e) { console.error(e); }
})();
})();
